import Prism from "prismjs";

Prism.languages["jsonata"] = {
  "jsonata-comment": {
    pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
    lookbehind: true,
    greedy: true,
  },
  "jsonata-string": [/'([^']*)'/, /"([^"]*)"/],
  "jsonata-variable": /\$[a-zA-Z0-9_]*/,
  "jsonata-name": /[a-zA-Z0-9_]+/,
};
